class AccordionManager {
  constructor() {
    this.initializedSections = new Set();
    this.TRANSITION_DURATION = 250;
    this.isAnimating = false;
  }

  initSection(sectionId) {
    if (this.initializedSections.has(sectionId)) return;
    this.initializedSections.add(sectionId);

    const container = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    if (!container) return;

    const buttons = container.querySelectorAll("[data-accordion-toggle]");
    const collapses = container.querySelectorAll(".accordion-collapse");

    // Reset all
    collapses.forEach((collapse) => {
      collapse.style.height = "0";
      collapse.classList.remove("show");
    });

    buttons.forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });

    // ✅ MULTIPLE DEFAULT SUPPORT
    let defaultItems = container.querySelectorAll(
      ".accordion_item-basic[data-accordion-default]"
    );

    // Fallback → first item
    if (!defaultItems.length) {
      const firstItem = container.querySelector(".accordion_item-basic");
      if (firstItem) defaultItems = [firstItem];
    }

    // Open defaults
    defaultItems.forEach((item) => {
      const button = item.querySelector("[data-accordion-toggle]");
      const collapse = item.querySelector(".accordion-collapse");

      if (!button || !collapse) return;

      button.setAttribute("aria-expanded", "true");
      collapse.classList.add("show");
      item.classList.add("active");

      // Force correct height
      collapse.style.height = `${collapse.scrollHeight}px`;

      requestAnimationFrame(() => {
        collapse.style.height = "auto";
      });
    });

    // Events
    buttons.forEach((button) => {
      button.addEventListener("click", (evt) =>
        this.handleAccordion(evt, sectionId)
      );
    });
  }

  handleAccordion(evt, sectionId) {
    if (this.isAnimating) return;

    const button = evt.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const targetId = button.getAttribute("aria-controls");
    const targetCollapse = document.getElementById(targetId);

    if (!targetCollapse || targetCollapse.classList.contains("collapsing"))
      return;

    this.isAnimating = true;

    const container = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );

    const allButtons = container.querySelectorAll(
      "[data-accordion-toggle]"
    );

    // Close others (single-open behavior)
    allButtons.forEach((btn) => {
      if (btn === button) return;

      const otherCollapse = document.getElementById(
        btn.getAttribute("aria-controls")
      );

      if (otherCollapse && otherCollapse.classList.contains("show")) {
        btn.setAttribute("aria-expanded", "false");

        otherCollapse.classList.add("collapsing");
        otherCollapse.classList.remove("show");

        otherCollapse.style.height = `${otherCollapse.scrollHeight}px`;
        void otherCollapse.offsetHeight;
        otherCollapse.style.height = "0";

        setTimeout(() => {
          otherCollapse.classList.remove("collapsing");
          btn.closest(".accordion_item-basic")?.classList.remove("active");
        }, this.TRANSITION_DURATION);
      }
    });

    // Toggle current
    if (!isExpanded) {
      button.setAttribute("aria-expanded", "true");

      targetCollapse.classList.add("collapsing", "show");
      button.closest(".accordion_item-basic")?.classList.add("active");

      targetCollapse.style.height = "0";
      const height = targetCollapse.scrollHeight;
      targetCollapse.style.height = `${height}px`;

      setTimeout(() => {
        targetCollapse.classList.remove("collapsing");
        targetCollapse.style.height = "auto";
        this.isAnimating = false;
      }, this.TRANSITION_DURATION);
    } else {
      button.setAttribute("aria-expanded", "false");

      targetCollapse.classList.add("collapsing");
      targetCollapse.classList.remove("show");

      targetCollapse.style.height = `${targetCollapse.scrollHeight}px`;
      void targetCollapse.offsetHeight;
      targetCollapse.style.height = "0";

      setTimeout(() => {
        targetCollapse.classList.remove("collapsing");
        button.closest(".accordion_item-basic")?.classList.remove("active");
        this.isAnimating = false;
      }, this.TRANSITION_DURATION);
    }
  }
}

// Init
const accordionManager = new AccordionManager();

window.initAccordionSection = (sectionId) => {
  accordionManager.initSection(sectionId);
};